module.exports = __webpack_public_path__ + "static/media/meaningful-review-product4-full.97a56118.svg";